// import React from 'react';
import React, { useState } from 'react';
import Map from '@common/components/map/GoogleMap';
import {
  InfoWindow, Marker,
} from '@react-google-maps/api';

import {
  Spin, Card, Button, Checkbox,
} from 'antd';

import { useTranslation } from 'react-i18next';

import CenteredContent from '@common/components/ui/CenteredContent';
import invertesIcon from '@assets/img/markers/convertidor/icon-inverters.png';

// import MenuItem from 'antd/lib/menu/MenuItem';
import useMapForVehicle from './useMapForVehicle';
import styles from './MapForVehicle.module.less';

function MapForVehicle() {

  const { t } = useTranslation();
  const [activeMarker, setActiveMarker] = useState(null);
  const {
    devices, onChangeDevices, loading, filterDevices,
  } = useMapForVehicle();

  const handleActiveMarker = (marker) => {

    if (marker === activeMarker) {

      return;

    }
    setActiveMarker(marker);

  };

  return (
    <div className={styles.map}>
      <div className={styles.total_inverters}>
        <Checkbox onChange={onChangeDevices} defaultChecked>
          {t('views.device_graphics.total_gateway')}
          {devices?.length || 0}
        </Checkbox>
      </div>

      {(() => {

        if (loading) {

          return (
            <CenteredContent>
              <Spin tip={t('views.device_graphics.loading_data_graphs')} />
            </CenteredContent>
          );

        }

        return (
          <div className="container_map">
            <Map>
              <>
                {filterDevices.map((device) => {

                  if (device?.gateway?.latitude !== '' && device?.gateway?.longitude) {

                    const position = { lat: device?.gateway?.latitude, lng: device?.gateway?.longitude };

                    return (
                      <Marker
                        key={device.id}
                        icon={{
                          url: invertesIcon,
                        // anchor: new window.google.maps.Point(50, 58),
                        }}
                        position={position} 
                        onClick={() => handleActiveMarker(device.id)}
                      >
                        {activeMarker === device.id ? (  
                            <InfoWindow onCloseClick={() => setActiveMarker(null)} options={{ maxWidth: 320 }}>
                              <div>
                                <h4> Gateway: {device?.gateway?.name} </h4> 
                              </div>
                            </InfoWindow> 
                        ) : null}
                      </Marker>

                    );

                  }

                })}
              </>
            </Map>
          </div>
        );

      })()}

    </div>
  );

}

export default MapForVehicle;
